import React from 'react';
import { Parallax } from 'react-parallax';
import './Section.ChooseUs.styles.css';
import config from './data/config.json';

const SectionChooseUs = () => {
  return (
    <div className="bg-green">
      <div className="container">
        <div className="row">
          {/* 1/3 Column with Parallax Background Image */}
          <div className="col-md-4 p-0 d-none d-md-block">
            <Parallax
              bgImage="/images/bottle.webp"
              strength={200}
              className="parallax-img-container"
            >
              <div className="image-content" />
            </Parallax>
          </div>

          {/* 2/3 Column */}
          <div className="col-md-8 text-white">
            <div className="container d-flex flex-column justify-content-center h-100">
              <div className="row">
                <h2 className="text-center w-100 mb-4 mt-4">Why Choose Us</h2>
                {config.chooseSection.map((item, index) => (
                  <div className="col-12 col-md-6 mb-4" key={index}>
                    <div className="d-flex">
                      <img
                        src="/images/bullet.svg"
                        alt="Bullet"
                        style={{ width: 20, height: 20, marginTop: 6 }}
                        className="flex-shrink-0 me-3"
                      />
                      <div className="text-start text-justify">
                        <h4 className="mb-1">{item.title}</h4>
                        <p className="mb-0">{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionChooseUs;
